<h3>View History</h3>
<app-table
		[downloadHeading]="downloadHeading"
		[downloadName]="downloadName"
		[data]="results"
		[headerClass]="'table-info'"
		[columns]="columnRef"
		[loading]="loading"
		(onUpdateRequired)="doFetchResult($event)">
	<ng-template #date let-row="row">
		<td>{{row.date | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
	</ng-template>
</app-table>
